module.exports = __webpack_public_path__ + "static/media/iconSectionFincance.486bdab2.svg";